import React, {
	useCallback,
	useContext,
	useEffect,
	useRef,
	useState,
} from 'react';
import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import SideMenu from '../../Splitter/SideMenu/SideMenu';
import { signed_offer_circle } from '../../../utils/images';
import QuoteElementExpert from '../QuoteElementExpert/QuoteElementExpert';
import { ExpertContext } from '../../Contexts/contexts';
import { shouldFetchData, status } from '../../../data/fetchStatus';
import useToast from '../../Toasts/useToast';
import {
	ToastHeaders,
	ToastThemes,
	ToastMessages,
} from '../../Toasts/ToastOptions/toastOptions';
import Services from '../../Services/services';
import useAuth from '../../Contexts/useAuth';
import useCheckout from '../../Contexts/useCheckout';
import usePaymentPeriod from '../../Contexts/usePaymentPeriod';

function PaymentQuoteExpert() {
	const expertContext = useContext(ExpertContext);

	const [clients, setClients] = useState([]);
	const [clientsFetched, setClientsFetched] = useState(status.DEFAULT);

	const enqueueToast = useToast();
	const { checkAuth, validateRoleRoute } = useAuth();
	const checkout = useCheckout();
	const checkPaymentPeriod = usePaymentPeriod();
	const ref = useRef(true);

	const fetchClients = useCallback(async () => {
		if (
			expertContext?.clientExpertRelations?.length === 0 ||
			clientsFetched === status.FETCHED
		)
			return;

		setClientsFetched(status.FETCHED);

		try {
			let clientsIds = [];

			expertContext
				?.getClientExpertRelationsByStatus([3, 4])
				.filter((cer) => cer.expertSigned === 1)
				.forEach((clientExpertRelation) => {
					clientsIds.push(clientExpertRelation.clientId);
				});

			const data = await Services.profileService.clientsByIDs(clientsIds, true);

			if (data.length === 0) return;

			setClients(data);
		} catch (error) {
			enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
				theme: ToastThemes.toastThemes.ERROR_OCCURED,
				header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
				duration: 3000,
			});
		}
	}, [expertContext, clientsFetched, enqueueToast]);

	useEffect(() => {
		if (checkAuth()) {
			if (validateRoleRoute('expert')) {
				if (checkout('/payment-quote')) {
					if (checkPaymentPeriod('/payment-quote')) {
						const firstRendering = ref.current;

						if (firstRendering) {
							ref.current = false;
							expertContext?.refreshClientExpertRelations();
							expertContext?.refreshAppointments();
						} else {
							if (shouldFetchData(clientsFetched)) fetchClients();
						}
					}
				}
			}
		}
	}, [
		clientsFetched,
		fetchClients,
		checkAuth,
		validateRoleRoute,
		checkout,
		checkPaymentPeriod,
		expertContext,
	]);

	// Fonction qui permet d'afficher les rdv acceptes
	function getAllRdvElements() {
		const rdvElementsItems = [];

		expertContext
			?.getClientExpertRelationsByStatus([3, 4])
			.filter(
				(cer) =>
					cer.expertSigned === 1 && cer?.expertCommission?.finishedAt === null
			)
			.forEach((clientExpertRelation) => {
				rdvElementsItems.push(
					<QuoteElementExpert
						clientExpertRelation={clientExpertRelation}
						client={clients?.find((client) => {
							return client?.userId === clientExpertRelation?.client?.userId;
						})}
						appointment={getAppointment(clientExpertRelation.id)}
						key={clientExpertRelation.id}
					/>
				);
			});

		return rdvElementsItems;
	}

	function getAppointment(clientExpertRelationshipId) {
		const appointment = expertContext?.appointments.filter(
			(item) => item?.clientExpertRelationshipId === clientExpertRelationshipId
		);

		return appointment.length > 0 ? appointment[0] : undefined;
	}

	return (
		<>
			<HeaderMinimal />
			<div className="ts-container">
				<SideMenu />
				<div className="ts-container-main">
					<div className="ts-details-container">
						<div className="ts-details">
							<div className="ts-title">Commissions à payer</div>
							<div className="ts-resume">
								La signature de votre devis a été confirmée de votre côté.
								<br />
								Pour accéder au paiement de la commission, veuillez cliquer sur
								l'icône en forme d'œil située à droite des informations du
								client.
								<br />
							</div>
						</div>
						<div className="ts-number">
							<div className="ts-number-container">
								<div className="ts-number-title">Devis signé</div>
								<div className="ts-number-current">
									{
										expertContext
											?.getClientExpertRelationsByStatus([3, 4])
											.filter(
												(cer) =>
													cer.expertSigned === 1 &&
													cer?.expertCommission?.finishedAt === null
											).length
									}
								</div>
							</div>
							<img
								className="ts-icon"
								src={signed_offer_circle}
								alt="devis icone"
							></img>
							<div className="blue-rod"></div>
						</div>
					</div>
					{expertContext
						?.getClientExpertRelationsByStatus([3, 4])
						.filter(
							(cer) =>
								cer.expertSigned === 1 &&
								cer?.expertCommission?.finishedAt === null
						).length > 0 ? (
						<div className="rdv-container">
							<div className="rdv-elements-container">
								{getAllRdvElements()}
							</div>
						</div>
					) : (
						<></>
					)}
				</div>
			</div>
		</>
	);
}

export default PaymentQuoteExpert;
